import { BreakpointObserver } from '@angular/cdk/layout';
import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { isMobileNavigationUrl, MOBILE_NAVIGATION_ITEMS, MOBILE_VIEW_QUERY } from '../utils/mobile-navigation.utils';

export const mobileNavigationGuard: CanActivateChildFn = (_route, state) => {
    const breakpointObserver = inject(BreakpointObserver);
    const router = inject(Router);

    if (!breakpointObserver.isMatched(MOBILE_VIEW_QUERY) || isMobileNavigationUrl(router.parseUrl(state.url))) {
        return true;
    }

    return router.createUrlTree([MOBILE_NAVIGATION_ITEMS[0].path]);
};